export default __webpack_public_path__ + "static/media/edit-composition.3677cd2d.svg";